/**
 * 权限管理 mock
 * http://mockjs.com/
 url： https://testzsqy.cheanjia.com/?mock=1#/sms/4
 */
import Mock from 'mockjs'
import cache from '../../common/cache'

let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'
// 业务统计
Mock.mock(/common\/current_user_info/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'name': '皮皮虾',
    'permissions': [
      'sale_potential_customer.manage',
      'sale_potential_customer.follow',
      'sale_clue.follow_self',
      'busi_analysis.zs_used_car_ticket',
      'zs_used_car_ticket.follow',
      'zs_used_car_ticket.create_from_car_visit',
      'zs_used_car_ticket.manage',
      'auction_car.view',
      'car_visit_to_used_car.manage',
      'used_car_ticket.manage',
      'used_car_car.manage',
      'used_car_ticket.create_enquiry',
      'used_car_car.enquiry.manage',
      'used_car_car.auction.manage',
      'used_car_car.enquiry.create',
      'used_car_car.auction.create',
      'car_visit_to_used_car.read_ticket',
      'used_car_outbound.management',
      'report.view_self',
      'busi_analysis.car_visit',
      'used_car_outbound.review.financial',
      'used_car_outbound.review.business',
      'used_car_outbound.request'
    ]
  },
  'message': 'ok'
})
